/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateMemoryStoreRequest = {
  memoryStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  updateMemoryStoreRequest: components.UpdateMemoryStoreRequest;
};

/** @internal */
export const UpdateMemoryStoreRequest$inboundSchema: z.ZodType<
  UpdateMemoryStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  memory_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  UpdateMemoryStoreRequest: components.UpdateMemoryStoreRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "memory_store_id": "memoryStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "UpdateMemoryStoreRequest": "updateMemoryStoreRequest",
  });
});
/** @internal */
export type UpdateMemoryStoreRequest$Outbound = {
  memory_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  UpdateMemoryStoreRequest: components.UpdateMemoryStoreRequest$Outbound;
};

/** @internal */
export const UpdateMemoryStoreRequest$outboundSchema: z.ZodType<
  UpdateMemoryStoreRequest$Outbound,
  z.ZodTypeDef,
  UpdateMemoryStoreRequest
> = z.object({
  memoryStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
  updateMemoryStoreRequest: components.UpdateMemoryStoreRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    memoryStoreId: "memory_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    updateMemoryStoreRequest: "UpdateMemoryStoreRequest",
  });
});

export function updateMemoryStoreRequestToJSON(
  updateMemoryStoreRequest: UpdateMemoryStoreRequest,
): string {
  return JSON.stringify(
    UpdateMemoryStoreRequest$outboundSchema.parse(updateMemoryStoreRequest),
  );
}
export function updateMemoryStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateMemoryStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateMemoryStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateMemoryStoreRequest' from JSON`,
  );
}
